// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2YMOX","fileBtn":"File_fileBtn__1pSV-","closeBtn":"File_closeBtn__2-UTI","fileSelected":"File_fileSelected__3bPyR","disabled":"File_disabled__vpI58"};